
import { ContactsService, EnumService, IContact, IAccount, AccountsService, Masterdata } from '../../../services';


class ContactsListController {

    private search: string;
    private tag: string;
    private company: string;
    private contacts: IContact[];
    private accounts: IAccount[];
    private contactsService: any;
    private accountId: any;
    private contactTags: Masterdata[];

    constructor(
        private ContactsService: ContactsService,
        private MasterdataService: aboMasterdata.IService,
        private EnumService: EnumService,
        private $stateParams: ng.ui.IStateParamsService) {
        'ngInject';
        // console.log('ContactsListController');

        this.contactsService = ContactsService;
    }

    public $onInit = () => {
        this.getMasterdata();
    }


    getMasterdata() {
        this.MasterdataService.getItems('ContactTags').then(res => {
            this.contactTags = res;
        });
    }


    emailToClipboard() {
        var emailsList = [];
        this.contacts.forEach(e => {
            if (e.emailAddress &&
                ((this.search && e.name.toUpperCase().indexOf(this.search.toUpperCase()) !== -1) || !this.search) &&
                ((this.tag && e.tags.indexOf(this.tag) !== -1) || !this.tag) &&
                ((this.company && e.accountName.toUpperCase().indexOf(this.company.toUpperCase()) !== -1) || !this.company)) {
                emailsList.push(e.emailAddress);
            }
        });

        // console.log(emailsList.join(';'));
        window.prompt("Ctrl+C to copy to clipboard, then paste in the BCC field of an email:", emailsList.join(';'));
    }

    resetFilter() {
        this.company = '';
        this.search = '';
        this.tag = '';
    }
}

export const contactsListComponent = {
    bindings: {
        contacts: '<',
        accounts: '<'
    },
    controller: ContactsListController,
    template: require('./contacts.list.html')
};



// WEBPACK FOOTER //
// ./src/app/modules/crm/contacts/contacts.list.component.ts